export default "__VITE_ASSET__ByqVBkDN__"